import { useQuery } from "@apollo/client";
import { useJsonForms, withJsonFormsControlProps } from "@jsonforms/react";
import { useEffect } from "react";
import { findInstantWinSummaryById } from "../../../graphql/queries/instantWinQueries";

const AddWinningScheduleRewardsInfo = (props) => {
  const { handleChange, path } = props || {};
  const ctx = useJsonForms();
  const formData = ctx.core.data;
  const { data: queryData } = useQuery(findInstantWinSummaryById, {
    variables: {
      id: formData?.instant_win_id,
    },
    skip: !formData?.instant_win_id,
    fetchPolicy: "network-only",
  });

  useEffect(() => {
    if (
      formData?.instant_win_id &&
      queryData?.findInstantWinById?.prizeSeedSummary?.length
    ) {
      const rewardsIds = queryData?.findInstantWinById?.prizeSeedSummary?.map(
        (summary) => summary.rewardId
      );
      handleChange(path, rewardsIds);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formData?.instant_win_id, queryData?.findInstantWinById]);

  // this component returns nothing
  return null;
};

export const AddWinningScheduleRewardsInfoControl = withJsonFormsControlProps(
  AddWinningScheduleRewardsInfo
);
export default AddWinningScheduleRewardsInfo;
